import { Component, VERSION, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'my-app',
	template: '<router-outlet></router-outlet>',
	encapsulation: ViewEncapsulation.None
})
export class AppComponent { 
	constructor() {
		console.log(VERSION.full); // print 2.3.0-rc.0
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts